window.global = window;
